window.global = window;
